import { render, staticRenderFns } from "./SetPrescriptionDialog.vue?vue&type=template&id=08bd2272&scoped=true"
import script from "./SetPrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./SetPrescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./SetPrescriptionDialog.vue?vue&type=style&index=0&id=08bd2272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd2272",
  null
  
)

export default component.exports